"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepJobDetailOption = void 0;
exports.PrepJobDetailOption = {
    BILLING: "BILLING",
    BOX_BUILDING: "BOX_BUILDING",
    CARTON_LABEL: "CARTON_LABEL",
    COMPLETED_QUANTITIES: "COMPLETED_QUANTITIES",
    FLOOR_LOADED_CONTAINER: "FLOOR_LOADED_CONTAINER",
    KITTING: "KITTING",
    PALLET_LABEL: "PALLET_LABEL",
    SAVED_QUANTITIES: "SAVED_QUANTITIES",
    SKU_DETAILS: "SKU_DETAILS",
    WHOLESALE: "WHOLESALE",
};
//# sourceMappingURL=prep-job-detail-option.js.map